import React from 'react'
import Chip, { chipClasses } from '@mui/material/Chip'

export interface IProps {
  colour: string
}

export class ColourLabel extends React.Component<IProps> {
  render() {
    const { colour } = this.props

    return (
      <Chip
        label={colour}
        sx={{
          backgroundColor: colour,
          [`&.${chipClasses.root}`]: { height: theme => theme.spacing(2) },
          [`& .${chipClasses.label}`]: { fontSize: 0, width: theme => theme.spacing(5) }
        }}
      />
    )
  }
}
